import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "disabled", "name", "value", "id", "checked"],
    _excluded2 = ["control", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import clsx from 'clsx';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioInput = /*#__PURE__*/forwardRef(function RadioInput(_ref, ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      name = _ref.name,
      value = _ref.value,
      id = _ref.id,
      checked = _ref.checked,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    className: "radio-input relative flex items-center",
    role: "radio",
    "aria-disabled": disabled,
    "aria-checked": checked,
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx('box border border-black/20 bg-white', {
        'cursor-pointer': !disabled
      }),
      children: checked && /*#__PURE__*/_jsx("div", {
        className: clsx('check-mark bg-brand-primary h-full w-full', {
          'bg-brand-primary/50': disabled
        })
      })
    }), /*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      id: id,
      type: "radio",
      role: "presentation",
      name: name,
      value: value,
      className: clsx('absolute top-0 left-0 right-0 bottom-0 opacity-0', {
        'cursor-pointer': !disabled
      }),
      disabled: disabled
    }, props)), /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: clsx('p-small ml-2 select-none', {
        'cursor-pointer': !disabled
      }),
      children: label
    })]
  });
});
export var RadioInputControlled = function RadioInputControlled(_ref2) {
  var control = _ref2.control,
      name = _ref2.name,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_jsx(RadioInput, _objectSpread(_objectSpread(_objectSpread({}, field), props), {}, {
        value: value,
        checked: field.value === value
      }));
    }
  });
};